import { AcessoCbo } from 'graphql/types.generated'
import { NIVEL_SUPERIOR, NIVEL_TECNICO } from 'types/NivelCbo'

export const grupoCboAntecedentes = [
  AcessoCbo.MEDICO,
  AcessoCbo.CIRURGIAO_DENTISTA,
  AcessoCbo.OUTRO_PROF_NIVEL_SUPERIOR,
  AcessoCbo.ENFERMEIRO,
  AcessoCbo.TSB,
  AcessoCbo.NIVEL_MEDIO,
  AcessoCbo.PSICOLOGO,
  AcessoCbo.NUTRICIONISTA,
]

export const grupoCboVisualizarAntecedentes = [...NIVEL_SUPERIOR, AcessoCbo.NIVEL_MEDIO, ...NIVEL_TECNICO]
